export default __webpack_public_path__ + "static/media/rooms2.507a3fec.png";